import type { DocsCostClass } from "../types";

/** Shared class strings for the docs page (full strings, so Tailwind sees every class). */

export const MONO = "font-[family-name:var(--font-geist-mono)]";

export const LINK = "text-[#66c0f4] underline-offset-2 hover:text-[#88d0ff] hover:underline";

export const INLINE_CODE = `${MONO} rounded bg-[#0e1620] px-1 py-px text-[0.88em] text-[#d6e6f2] ring-1 ring-inset ring-[#2a475e]/70 [overflow-wrap:anywhere]`;

/** One colour per cost class, used by the badges and the cost table. */
export const COST_COLOR: Record<DocsCostClass, string> = {
  free: "#a4d007",
  lookup: "#66c0f4",
  series: "#a78bfa",
  forecast: "#e35e1c",
};

export function unitsLabel(units: number): string {
  if (units === 0) return "Free";
  return `${units} unit${units === 1 ? "" : "s"}`;
}

export function formatCount(n: number): string {
  return n.toLocaleString("en-US");
}
